import * as React from 'react';
import { useLayer, useHover, Arrow } from 'react-laag';
import { motion, AnimatePresence } from 'framer-motion';

import Heading from '../typography';
import { COLORS } from '../../constants/style/color';
import {
  TooltipComponentContainer,
  TooltipComponentWrapper,
  TooltipContent,
} from './hover-tooltip.styled';

export function HoverTooltip({ children, text, placement, size, variant }) {
  const [isOver, hoverProps] = useHover({ delayEnter: 100, delayLeave: 300 });
  const [isTooltipHovered, setTooltipHovered] = React.useState(false);

  // Tell `useLayer()` how we would like to position our tooltip
  const { triggerProps, layerProps, arrowProps, renderLayer } = useLayer({
    isOpen: isOver,
    placement: placement,
    triggerOffset: 8, // small gap between wrapped content and the tooltip
  });

  let trigger;
  if (isReactText(children)) {
    trigger = (
      <span className='tooltip-text-wrapper' {...triggerProps} {...hoverProps}>
        {children}
      </span>
    );
  } else {
    // In case of an react-element, we need to clone it in order to attach our own props
    trigger = React.cloneElement(children, {
      ...triggerProps,
      ...hoverProps,
    });
  }

  return (
    <TooltipComponentContainer>
      {trigger}
      {renderLayer(
        <>
          {(isOver || isTooltipHovered) && (
            <TooltipComponentWrapper
              size={size ?? 'md'}
              variant={variant ?? 'light'}
              className='tooltip-box'
              onMouseEnter={() => setTooltipHovered(true)}
              onMouseLeave={() => setTooltipHovered(false)}
              {...layerProps}>
              <TooltipContent>
                <Heading variant='body-s' title={text} />
              </TooltipContent>
              <Arrow
                {...arrowProps}
                backgroundColor={variant === 'dark' ? COLORS.Black : COLORS.White}
                borderColor={variant === 'dark' ? COLORS.Black : COLORS.White}
                borderWidth={1}
                size={6}
              />
            </TooltipComponentWrapper>
          )}
        </>
      )}
    </TooltipComponentContainer>
  );
}

function isReactText(children) {
  return ['string', 'number'].includes(typeof children);
}
